// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ZEP1","type":"styles_type__2RwYV","choices":"styles_choices__oDn2D"};